import React, { useEffect, useState } from "react";
import BottomNav from "../../components/BottomNav/BottomNav";
import InnerHeader from "../../components/InnerHeader";

import "./ChangePassword.css";
import { changePassword } from "../../api/auth.api";
import UserBalanceHero from "../../components/UserBalanceHero/UserBalanceHero";

export default function ChangePassword({

}) {
  const [current, setCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  /* -------------------------------
     Password validation
  --------------------------------*/
  function validatePassword(value) {
    return {
      length: value.length >= 6 && value.length <= 20,
      uppercase: /[A-Z]/.test(value),
      lowercase: /[a-z]/.test(value),
      number: /[0-9]/.test(value),
      special: /^[A-Za-z0-9!@#$%]*$/.test(value) && /[!@#$%]/.test(value),
    };
  }

  function isPasswordValid(value) {
    const r = validatePassword(value);
    return Object.values(r).every(Boolean);
  }

  const rules = validatePassword(password);
  const isValid = isPasswordValid(password) && password === confirm;

  /* -------------------------------
     Example fetch (as you provided)
  --------------------------------*/
  useEffect(() => {
    const fetchMessages = async () => {
      const token = localStorage.getItem("token");

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/payment-methods`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.ok) {
          const data = await response.json();
          console.log("data", data);
        } else {
          console.error("Failed to fetch messages.");
        }
      } catch (fetchError) {
        console.error("Error fetching messages:", fetchError);
      }
    };

    fetchMessages();
  }, []);

  /* -------------------------------
     Submit handler
  --------------------------------*/
  const handleChangePassword = async () => {
    setError("");
    setSuccess("");

    if (!current.trim()) {
      setError("Old password is required.");
      return;
    }

    if (!password.trim()) {
      setError("New password is required.");
      return;
    }

    if (!confirm.trim()) {
      setError("Confirm password is required.");
      return;
    }

    if (!isPasswordValid(password)) {
      setError(
        "Password must be 6-20 characters and include uppercase, lowercase, number, and one special character (!@#$%)."
      );
      return;
    }

    if (password !== confirm) {
      setError("Confirm password does not match.");
      return;
    }

    try {
      setLoading(true);

      const res = await changePassword({
        old_password: current,
        new_password: password,
        new_password_confirmation: confirm,
      });

      if (res?.data?.status === "success") {
        setSuccess(res.data.message || "Password changed successfully.");
        setCurrent("");
        setPassword("");
        setConfirm("");

        // If you want force re-login, uncomment:
        // localStorage.clear();
        // setTimeout(() => {
        //   window.location.href = "/login";
        // }, 1500);
      } else {
        setError(res?.data?.message || "Password change failed");
      }
    } catch (err) {
      setError(
        err?.response?.data?.message || "Something went wrong. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleChangePassword();
  };

  return (
    <div className="cpw-page">
      <InnerHeader title="Change Password" />

      <UserBalanceHero />

      <div className="cpw-content">
        <div className="cpw-section-pill">Change Password</div>

        <form className="cpw-form" onSubmit={handleSubmit}>
          <input
            type="password"
            className="cpw-input"
            placeholder="Old Password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
          />

          <input
            type="password"
            className="cpw-input"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <input
            type="password"
            className="cpw-input"
            placeholder="Confirm Password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />

          {password ? (
            <div className="cpw-rules">
              <div className={rules.length ? "cpw-rule ok" : "cpw-rule"}>
                6-20 characters
              </div>
              <div className={rules.uppercase ? "cpw-rule ok" : "cpw-rule"}>
                1 uppercase letter
              </div>
              <div className={rules.lowercase ? "cpw-rule ok" : "cpw-rule"}>
                1 lowercase letter
              </div>
              <div className={rules.number ? "cpw-rule ok" : "cpw-rule"}>
                1 number
              </div>
              <div className={rules.special ? "cpw-rule ok" : "cpw-rule"}>
                1 special (!@#$%)
              </div>
            </div>
          ) : null}

          {error ? <div className="cpw-message cpw-error">{error}</div> : null}
          {success ? (
            <div className="cpw-message cpw-success">{success}</div>
          ) : null}

          <button
            type="submit"
            className="cpw-submit-btn"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>

      <BottomNav />
    </div>
  );
}